var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"timeline-wrapper"},_vm._l((_vm.ticks),function(tick,index){return _c('div',{key:index,staticClass:"tick"},[_c('span',[_vm._v(_vm._s(tick))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }